import React, { Component } from 'react';
import { getCurso, getListadoCursos } from '../actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CursoItem from '../components/curso_item';

class ListadoCursos extends Component {
  constructor(props){
    super(props);
    let usr = false;
    if(props.deusuario!==undefined){
      usr = props.deusuario==="1";
    }


    this.state = { parausuario: usr };
  }

  componentDidMount(){
    this.props.getCurso(null);
    let busqueda = this.props.match.params.busqueda;
    if (busqueda) {
      this.props.getListadoCursos(busqueda);
    }else{
      this.props.getListadoCursos();
    }
  }

  renderList(){
    let lista =  this.props.listado_cursos;
    if (lista===null || lista.length<=0) {
      return (
        <div className="card card-full">
          <div className="card-body">
            <h5 className="card-title">No hay cursos que mostrar</h5>
          </div>
        </div>
      );
    }else{
      if(!this.state.parausuario){
        return lista.map((curso)=>{
          return (
            <CursoItem curso={curso} alumno={this.props.usuario} key={curso.id}/>
          );
        });
      } else if(this.props.usuario==null){
        return (
          <div className="card card-full">
            <div className="card-body">
              <h5 className="card-title">Inicie Sesión para ver sus cursos</h5>
            </div>
          </div>
        );
      } else {
        let listaAllow = this.props.usuario.cursosDisponibles;
        return lista.map((curso)=>{
          if(listaAllow.indexOf(curso.id)<0){
            return (<span key={`NOLOAD${curso.id}`} hidden />);
          } else {
            return (
              <CursoItem curso={curso} alumno={this.props.usuario} />
            );
          }
        });

      }
    }
  }

  render(){
    if (this.props.listado_cursos===null) {
      return (
        <section id="course-detail">
          <div className="container">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Cargando...</h5>
              </div>
            </div>
          </div>
        </section>
      );
    }
    return (
      <section id="courses-list">
        <div className="container">
          <div className="row">
            {this.renderList()}
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps({ listado_cursos, usuario }) {
  return { listado_cursos, usuario  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getCurso,
    getListadoCursos
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ListadoCursos);



// WEBPACK FOOTER //
// ./src/containers/listado_cursos.js